import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.inter = setInterval(() => {
      // window.location.reload()
      fetch('/', {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      }).then(response => response.text())
        .then(html => {
          document.body.insertAdjacentHTML('beforeend', html); // 插入Turbo Stream指令
        });
      // Turbo.visit(window.location.href);
    },30000);

  }

  disconnect() {
    clearInterval(this.inter)
  }
}
